var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"url":"wallerpaymentrequested","title":"درخواست های پرداخت درگاه های بین المللی","detailUrl":"paynationalprq","fields":_vm.fields,"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }